
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/album/[...p]",
      function () {
        return require("private-next-pages/album/[...p].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/album/[...p]"])
      });
    }
  